import React, { useState, useEffect, useRef } from 'react';
import { Dropdown, FormControl } from 'react-bootstrap';
const MIN_SEARCH_TERM_LENGTH = 3;

export const SearchableDropdown = ({onSearch, onUpdate}) => {

  const [selectedOption, setSelectedOption] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [dropdownOpenToggle, setDropdownOpenToggle] = useState(false);
  const [optionsFiltered, setOptionsFiltered] = useState([]);
  const dropDownRef = useRef(null);
  //focus management on parent search bar
  useEffect(() => {
    if (dropDownRef && dropDownRef.current != null) {
      //console.log("setting parent focus");
      dropDownRef.current.focus();
    }
  }, [dropdownOpenToggle]);

  const dropdownToggled = (isOpening) => {
    if (isOpening) {
      if(searchTerm && searchTerm.length >= MIN_SEARCH_TERM_LENGTH){

      } else {
        setOptionsFiltered([])
      }
      setDropdownOpenToggle(!dropdownOpenToggle)
    }
  };

  const clearDropdown = (e) => {
    //called when uses clicks 'X' on parent dropdown
    if (e) { e.preventDefault(); e.stopPropagation(); } //prevent list from opening
    setSearchTerm("");
    setOptionsFiltered([]);
    selectOption(0,"")
  };

  const fetchResults = async (search='') => {
    const term = search.target.value;
    setSearchTerm(term);
     
    if (term && term.length >= MIN_SEARCH_TERM_LENGTH) {
      const optionsArray = await onSearch(term);
      setOptionsFiltered(optionsArray)
    } else {
      setOptionsFiltered([]);
    }
  }

  const selectOption = (optionId, label) => {
    const obj = {label: label, value: optionId}
    onUpdate(obj)
    setSelectedOption(label);
  };

  return (
    <Dropdown onToggle={dropdownToggled}>
      <Dropdown.Toggle variant="search" id="dropdown-basic">
        <div className="dropdown-container">
          <div className="dropdown-title">Contact</div>
          <div className="dropdown-value">{selectedOption ? selectedOption : "Select..."}</div>
          <div className="dropdown-clear" onClick={clearDropdown}><i className="fa fa-close" /></div>
          <span className="dropdown-line"></span>
          <div className="dropdown-caret"><i className="fa fa-chevron-down" /></div>
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu variant='search'>
        <FormControl
          ref={dropDownRef}
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={fetchResults}
        />
        <Dropdown.Divider />
        <div className="scrollContainer">
          {optionsFiltered.length !== 0 ? optionsFiltered.map((option) => (
            <Dropdown.Item eventKey={option.value} key={option.value} onClick={() => selectOption(option.value, option.label)}>
              {option.label}
            </Dropdown.Item>
          )) : null}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
